"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeUpdatedDataTimeOutEvent = exports.publishUpdatedDataTimeOutEvent = exports.TimeOutTypeEvent = void 0;
const events_1 = require("../../features/events");
const factory_1 = require("./factory");
var TimeOutTypeEvent;
(function (TimeOutTypeEvent) {
    TimeOutTypeEvent["UPDATED_DATA_TIMEOUT"] = "updatedDataTimeOutEvent";
})(TimeOutTypeEvent || (exports.TimeOutTypeEvent = TimeOutTypeEvent = {}));
exports.publishUpdatedDataTimeOutEvent = (0, factory_1.createPublishFunction)(TimeOutTypeEvent.UPDATED_DATA_TIMEOUT, events_1.UpdatedDataTimeOutEvent);
const subscribeUpdatedDataTimeOutEvent = (callback, eventBus) => (0, factory_1.createSubscribeFunction)(TimeOutTypeEvent.UPDATED_DATA_TIMEOUT)(callback, eventBus);
exports.subscribeUpdatedDataTimeOutEvent = subscribeUpdatedDataTimeOutEvent;
//# sourceMappingURL=timeOut.js.map